// services/atualizarEmpreendimento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
// --------------------- Import Interface ---------------------
import { Empreendimento } from "../interfaces/Empreendimento";

export const atualizarEmpreendimento = async (
  empreendId: number | undefined,
  valuesEmp: Empreendimento
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/empreendimento/${empreendId}`;
    try {
      const response = await axios.put(URL, valuesEmp, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
